var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20.373,
    viewBox: "0 0 19.999 20.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "categories",
    transform: "translate(-0.421 -0.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    d: "M1-.75H6.872A1.752,1.752,0,0,1,8.622,1V6.872a1.752,1.752,0,0,1-1.75,1.75H1A1.752,1.752,0,0,1-.75,6.872V1A1.752,1.752,0,0,1,1-.75ZM6.872,7.122a.25.25,0,0,0,.25-.25V1a.25.25,0,0,0-.25-.25H1A.25.25,0,0,0,.75,1V6.872a.25.25,0,0,0,.25.25Z",
    transform: "translate(1.171 1.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    d: "M1-.75H6.872A1.752,1.752,0,0,1,8.622,1V6.872a1.752,1.752,0,0,1-1.75,1.75H1A1.752,1.752,0,0,1-.75,6.872V1A1.752,1.752,0,0,1,1-.75ZM6.872,7.122a.25.25,0,0,0,.25-.25V1a.25.25,0,0,0-.25-.25H1A.25.25,0,0,0,.75,1V6.872a.25.25,0,0,0,.25.25Z",
    transform: "translate(11.798 1.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    d: "M1-.75H6.872A1.752,1.752,0,0,1,8.622,1V6.872a1.752,1.752,0,0,1-1.75,1.75H1A1.752,1.752,0,0,1-.75,6.872V1A1.752,1.752,0,0,1,1-.75ZM6.872,7.122a.25.25,0,0,0,.25-.25V1a.25.25,0,0,0-.25-.25H1A.25.25,0,0,0,.75,1V6.872a.25.25,0,0,0,.25.25Z",
    transform: "translate(1.171 12.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    d: "M1-.75H6.872A1.752,1.752,0,0,1,8.622,1V6.872a1.752,1.752,0,0,1-1.75,1.75H1A1.752,1.752,0,0,1-.75,6.872V1A1.752,1.752,0,0,1,1-.75ZM6.872,7.122a.25.25,0,0,0,.25-.25V1a.25.25,0,0,0-.25-.25H1A.25.25,0,0,0,.75,1V6.872a.25.25,0,0,0,.25.25Z",
    transform: "translate(11.798 12.064)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.a1e1f7ce00b9659e8f7042a5a227ba9a.svg";
export { ForwardRef as ReactComponent };